import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const Highlight = styled.mark.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "highlight",
  className: "Highlight",
})`
  background-color: ${rydeColors.highlightSearch};
`;

export const BlockHighlight = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "block-highlight",
  className: "BlockHighlight",
})`
  background-color: ${rydeColors.highlightSearch};
`;
